$(document).ready(function () {
  $.getScript("//cdnjs.cloudflare.com/ajax/libs/fancybox/2.1.5/jquery.fancybox.min.js").done(function () {
    quickView();
  });
});

function quickView() {
  $(".quick-view").click(function () {
    if ($("#quick-view").length == 0) {
      $("body").append('<div id="quick-view"></div>');
    }
    // var product_id;
    var size=$(this).data("size");
    // console.log(size);
    var product_handle = $(this).data("handle");
    $("#quick-view").addClass(product_handle);    
    // $("#size-chart").attr('src',size);
    jQuery.getJSON("/products/" + product_handle + ".js", function (product) {
      // console.log(product);
      product_id=product.id;
      var title = product.title;
      var type = product.type;
      var price = 0;
      var original_price = 0;
      var desc = product.description;
      var images = product.images;
      var variants = product.variants;
      var options = product.options;
      var url = "/products/" + product_handle;
      $("#size-chart").attr("src",size);
      $(".qv-product-title").text(title);
      $(".qv-product-type").text(type);
      // $(".qv-product-description").html(desc);
      $(".view-product").attr("href", url);
      var imageCount = $(images).length;
      $(images).each(function (i, image) {
        if (i == imageCount - 1) {
          var image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed
            .replace(".jpg", "_800x.jpg")
            .replace(".png", "_800x.png");
          $(".qv-product-images").append(image_embed);
          $(".qv-product-images").slick({
              dots: true,
              arrows: false,
              respondTo: "min",
              useTransform: false,
            })
            .css("opacity", "1");
        } else {
          image_embed = '<div><img src="' + image + '"></div>';
          image_embed = image_embed
            .replace(".jpg", "_800x.jpg")
            .replace(".png", "_800x.png");
          $(".qv-product-images").append(image_embed);
        }
      });

      $(options).each(function (i, option) {
        var opt = option.name;
        var selectClass = ".option." + opt.toLowerCase();
        $(".qv-product-options").append(
          '<div class="option-selection-' + opt.toLowerCase() + '"><span class="option">' + opt + '</span><select class="option-' + i + " option " + opt.toLowerCase() + '"></select></div>'
        );
        $(option.values).each(function (i, value) {
          $(".option." + opt.toLowerCase()).append('<option value="' + value + '">' + value + "</option>");
        });
      });

      $(product.variants).each(function (i, v) {
        price = parseFloat(v.price / 100).toFixed(2);
        original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
        $(".qv-product-price").text("₹" + price);
        if (original_price > 0) {
          $(".qv-product-original-price")
            .text("₹" + original_price)
            .show();
        } else {
          $(".qv-product-original-price").hide();
        }
        $("select.option-0").val(v.option1);
        $("select.option-1").val(v.option2);
        $("select.option-2").val(v.option3);
        return false;
      });
    });
     
               
    $(document).on("change", "#quick-view select", function () {
      var selectedOptions = "";
      $("#quick-view select").each(function (i) {
        if (selectedOptions == "") {
          selectedOptions = $(this).val();
        } else {
          selectedOptions = selectedOptions + " / " + $(this).val();
        }
      });
      jQuery.getJSON("/products/" + product_handle + ".js", function (product) {
        $(product.variants).each(function (i, v) {
          if (v.title == selectedOptions) {
            var price = parseFloat(v.price / 100).toFixed(2);
            var original_price = parseFloat(v.compare_at_price / 100).toFixed(2);
            var v_qty = v.inventory_quantity;
            var v_inv = v.inventory_management;
            $(".qv-product-price").text("₹" + price);
            $(".qv-product-original-price").text("₹" + original_price);
            $(".qv-add-button").prop("disabled", false).val("Add to Cart");
          }
        });
      });
    });

    $.fancybox({
      href: "#quick-view",
      maxWidth: 1040,
      maxHeight: 600,
      fitToView: true,
      width: "90%",
      height: "75%",
      autoSize: false,
      closeClick: false,
      openEffect: "none",
      closeEffect: "none",
      beforeLoad: function () {
        var product_handle = $("#quick-view").attr("class");
        $(document).on("click", ".qv-add-button", function () {
          var qty = 1;
          var selectedOptions = "";
          var var_id = "";
          $("#quick-view select").each(function (i) {
            selectedOptions = $(this).val();
          });
          jQuery.getJSON("/products/" + product_handle + ".js",function (product) {
              $(product.variants).each(function (i, v) {
                if (v.title == selectedOptions) {
                  var_id = v.id;
                  processCart();
                }
              });
            }
          );
          async function processCart() {
            await jQuery.post("/cart/add.js",{
                  quantity: qty,
                  id: var_id,
            },null,"json").done(function () {
              if(window.openCart) monster_refresh();
                var product_handle = $("#quick-view").attr("class");
                jQuery.getJSON("/products/" + product_handle + ".js",function (product) {
                    window.dataLayer.push({
                      event: "addToCart",
                      ecommerce: {
                        currencyCode: "INR",
                        add: {
                          products: [
                            {
                              name: product.title,
                              id: product.id,
                              productId: product.id,
                              variantId: var_id,
                              shopifyId: "shopify_US_" + product.id + "_" + var_id,
                              price: product.price / 100,
                              brand: product.vendor.replace("'", ""),
                              variant: selectedOptions,
                              quantity: qty,
                              category: product.type,
                            },
                          ],
                        },
                      },
                    });
                  }
                );
                $(".qv-add-to-cart-response")
                  .addClass("success")
                  .html(
                    "<span>" +
                      $(".qv-product-title").text() +
                      ' has been added to your cart. <a href="/cart" id="go-to-cart">Click here to view your cart.</a>'
                  );
                $(".qv-add-to-cart-response.success").show();
                // document.querySelector("#go-to-cart").click();
              })

              .fail(function ($xhr) {
                var data = $xhr.responseJSON;
                $(".qv-add-to-cart-response")
                  .addClass("error")
                  .html("<span><b>ERROR: </b>" + data.description);
              });
          }
          $(document).off("click",".qv-add-button");
        });

        $(".fancybox-wrap").css("overflow", "hidden !important");
      },

      afterShow: function () {
        $("#quick-view")
          .hide()
          .html(content)
          .css("opacity", "1")
          .fadeIn(function () {
            $(".qv-product-images").addClass("loaded");
          });
      },

      afterClose: function () {
        $("#quick-view").removeClass().empty();
      },
    });
  });
}

$(window).resize(function () {
  if ($("#quick-view").is(":visible")) {
    $(".qv-product-images").slick("setPosition");
  }
});
